import UpSelect from 'Components/Inputs/UpSelect';

(function () {
	ReactTemplates.INPUTS.upSelect = UpSelect;
})();
